import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { TempCarrierId } from "features/airTimeManagement/presentation/constants/AirTimeManagementConstants";

export class AirtimeResponseEntity {
  createAt?: string;
  updateAt?: string;
  id?: string;
  name?: string;
  code?: string;
  amount?: string;
  status?: number;
  type?: number;
  description?: string;
  config?: string;
  order?: number;
  carrier?: string;

  constructor(data?: Partial<AirtimeResponseEntity>) {
    this.createAt = data?.createAt;
    this.updateAt = data?.updateAt;
    this.id = data?.id;
    this.name = data?.name;
    this.code = data?.code;
    this.amount = data?.amount;
    this.status = data?.status;
    this.type = data?.type;
    this.description = data?.description;
    this.config = data?.config;
    this.order = data?.order;
    this.carrier = data?.carrier;
  }

  static mapCarrierWithId(data: Array<BaseFilterListResponseModel>) {
    return data?.map((item) => ({
      id: TempCarrierId[item?.code],
      ...item,
    }));
  }
}
